module.exports = __webpack_public_path__ + "static/media/banner_jobank.4467a5cb.png";